<template>
  <div>
    <div >
      <!-- <h1>{{$t('userInfo.name')}}</h1> -->
      <!--顶部导航-->
      <navgate ></navgate>
      <!--内容区域-->
      <div class="web_box">
        <!--banner-->
        <div class="banner_box">
          <template v-if="mainData && mainData.introduce">
            <swiper
              :options="swiperOption"
            >
                <swiper-slide v-for="(item,index) in mainData.introduce.banners" :key="index"><img :src="item.bannerUrl" @click="clickBanner(item)"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"> </div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            
            </swiper>
          </template>
        </div>
        <div class="web_content">
          <!--新闻动态-->
          
          <div class="content_box">
            <div class="news_title">
              <div class="news_h3">新闻动态</div>
              <div class="news_more" @click="itemMoreClick('newsList')">更多</div>
            </div>
            <template v-if="mainData && mainData.introduce">
              <div class="list_box">
                <div class="news_list" v-for="(item,index) in mainData.introduce.messageNews" :key="index" @click="clickMessage(item)">
                  <img :src="item.msgUrl"  @error="setDefaultImage">
                  <div class="list_titlt">{{item.title}}</div>
                  <div class="list_date">{{item.createDate}}</div>
                </div>
              </div>
            </template>
            
          </div>
          <!--公益项目-->
          <div class="content_box">
            <div class="news_title">
              <div class="news_h3">公益项目</div>
              <div class="news_more" @click="itemMoreClick('fundProject')">更多</div>
            </div>
            
            <template v-if="mainData && mainData.introduce">
              <div class="list_box">
                <div class="news_list" v-for="(item,index) in mainData.introduce.fundProjects" :key="index" @click="clickFundation(item)">
                  <img :src="item.msgUrl"  @error="setDefaultImage">
                  <div class="list_titlt">{{item.title}}</div>
                  <div class="list_date">{{item.createDate}}</div>
                </div>
              </div>
            </template>
          </div>
          
          <!--合作伙伴-->
          <div class="content_box" style="display:none">
            <div class="news_title">
              <div class="news_h3">合作伙伴</div>
            </div>
            <div class="list_box">
              111
            </div>
          </div>
        </div>
        <!--联系我们-->
        <footer-build></footer-build>
      </div>
      <!--回到顶部-->
      <div class="top_box" @click="clickToTop" v-show="isShowTop">
        <div><i class="iconfont icon-web-top"></i></div>
      </div>
      
    </div>
    <!--<button @click="changLang">ccccc</button>-->
    <router-view/>
  </div>
  
</template>

<script>
import defaultImage from '../../assets/img/default_img.png'
import store from '../../store' 
import { mapState, mapGetters, mapActions } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import HttpUtils from "../../util/HttpUtils";
import 'swiper/dist/css/swiper.css'
export default {
  name: 'Introduce',
  components:{swiper, swiperSlide},
  props: {
    
  },
  created(){
    this.getMainData();
    let that = this;
   
  },
  data () {
    return {
      mainData:null,
      isShowTop:false,
      tHeight:0,
      swiperOption: {
          spaceBetween: 30,
          effect: 'fade',
          loop:true,
          autoplay:{
            delay:3000,
            disableOnInteraction:false
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
    }
  },
  
  methods:{
    
    ...mapActions("global", ["ActionSetNavigator"]),
    setDefaultImage(e){
      e.target.src = defaultImage
    },
    onscrollListener(){
      let _this = this;
      window.onscroll = function(){
        _this.tHeight = _this.getScrollTop();
        if(_this.tHeight > 400){
          _this.isShowTop = true;
        }else{
          _this.isShowTop = false;
        }
      }
    },
    getScrollTop(){
      let scrolltop = 0;
      if(document.documentElement && document.documentElement.scrollTop){
        scrolltop = document.documentElement.scrollTop;
      }else if(document.body){
         scrolltop = document.body.scrollTop;
      }
      return scrolltop;
    },
    clickBanner(item){
      if(item.messageId && item.messageId !=''){
        let url = this.$router.resolve({
          name: 'newsDetail',
          query: {detailId:item.messageId}
        });
        this.$PageUtil.openNewPage(this,url.href)
      }
    },
    clickMessage(item){
      

       let url = this.$router.resolve({
         name: 'newsDetail',
         query: {detailId:item.messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
      
    },
    clickToTop(){
      document.documentElement.scrollTop=0;
      document.body.scrollTop=0;
    },
    clickFundation(item){
      // window.open('/fundDetail','_blank')
      let url = this.$router.resolve({
         name: 'fundDetail',
         query: {detailId:item.messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
    },
    getMainData(){
      debugger;
      if(this.mainData == null){
        let that = this;
        new HttpUtils().sendGet(that, '/foundation_api/mainInfo.json',  { }, function (sucess, res) {
          that.mainData = res
          let tempNavigator = {programs:that.mainData.programs};
          that.ActionSetNavigator(tempNavigator);
        });
      }
      
    },
    itemMoreClick(pageName){
      this.$PageUtil.openNewPage(this,pageName)
    },
    
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      console.log(lang)  //控制台输出 'zh'
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    },
    
  },
  mounted(){
    this.onscrollListener();
    
    // document.addEventListener('click', this.HiddenClick)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
